// import React from 'react'
// import './css/exploreCaseStudy.css'
// import { HashLink as Link } from "react-router-hash-link";
// const caseStudies = [
//     {
//         id: 1,
//         tag: 'CUSTOMER STORY',
//         title: "Bridging healthcare data gaps",
//         location: 'Pacific West Diagnostic Imaging',
//         image: 'https://d2lyw5vkb9es5b.cloudfront.net/MRIBgImg.webp',
//         url: "/customer-stories/bridging-healthcare-data-gaps",
//         customerStory:'',
//         Industry:'',

//     },
//     {
//         id: 2,
//         tag: 'CUSTOMER STORY',
//         title: 'Seamless Connection. Lasting Impact.',
//         location: 'Debt Consultants Group',
//         image: 'https://d2lyw5vkb9es5b.cloudfront.net/DCGbannerImag.webp',
//         url: "/customer-stories/seamless-connection-lasting-impact"
//     },
//     {
//         id: 3,
//         tag: 'CUSTOMER STORY',
//         title: "Instant Alerts. Connected Care.",
//         location: 'PillTime',
//         image: 'https://d2lyw5vkb9es5b.cloudfront.net/card2.webp',
//         url: "/customer-stories/instant-alerts-connected-care"
//     },
//     {
//         id: 4,
//         tag: 'CUSTOMER STORY',
//         title: "Powering, Vision 2030",
//         location: 'World YMCA',
//         image: 'https://d2lyw5vkb9es5b.cloudfront.net/YMCA201.webp',
//         url: "/customer-stories/powering-vision-2030",
//     },
//     {
//         id: 5,
//         tag: 'CUSTOMER STORY',
//         title: "Proven Revenue, Smartly Delivered",
//         location: 'Elements Dining Group',
//         image: 'https://d2lyw5vkb9es5b.cloudfront.net/ChatGPT20Image20Feb20232C2020262C2012_25_2020PM.webp',
//         url: "/customer-stories/proven-revenue-smartly-delivered",
//     },
//     {
//         id: 6,
//         tag: 'CUSTOMER STORY',
//         title: 'Unified Patient Provider Digital Ecosystem',
//         location: 'ABA Therapy Provider',
//         image: 'https://d2lyw5vkb9es5b.cloudfront.net/ChatGPT20Image20Feb20182C2020262C2007_19_5020PM.webp',
//         url: "/customer-stories/unified-patient-provider-digital-ecosystem"
//     },
//     {
//         id: 7,
//         tag: 'CUSTOMER STORY',
//         title: 'Where Data Drives Community Change',
//         location: 'Grove Park Youth Club',
//         image: 'https://d2lyw5vkb9es5b.cloudfront.net/2a8b30_f9a15c9a693c40439e8b140a463726a4~mv2.webp',
//         url: "/customer-stories/where-data-drives-community-change"
//     },
// ];
// // const colorCode = ['#d1eb33', '#d12bdde0', '#2d58ed', '#ff7987']
// const colorCode = [
//     {
//         'backgroundColor': '#d1eb33',
//         'textColor': '#222',
//         'paraColor': '#666'
//     },
//     {
//         'backgroundColor': '#d12bdde0',
//         'textColor': '#fff',
//         'paraColor': '#fff'
//     },

//     {
//         'backgroundColor': '#ff7987',
//         'textColor': '#fff',
//         'paraColor': '#fff'
//     },
//     {
//         'backgroundColor': '#2d58ed',
//         'textColor': '#fff',
//         'paraColor': '#fff'
//     }
// ]
// export default function CustomerStory() {
//     return (
//       <div  style={{backgroundColor:'#fff'}}> 

//           <div className="container" id='customer-stories' style={{backgroundColor:'#fff'}}>
//             <div className="ExploreCaseStudySection" >
//                 <p className="sectionLabel">Customer Stories</p>
//                 {/* <h2>Explore our case studies, ideas, impact</h2> */}
//                    <h2>Featured Insights</h2>
//                 <div className='customer_story_container'>
//                     {caseStudies.map((item, index) => (
//                         <Link className="customer_story_card" key={index} to={item.url} style={{
//                             "--hoverBg": colorCode[index % colorCode.length].backgroundColor,
//                             "--titleColor": colorCode[index % colorCode.length].textColor,
//                             "--paraColor": colorCode[index % colorCode.length].paraColor
//                         }}>

//                             <div className="customer_story_card_image">
//                                 <img src={item.image} alt={item.location} />
//                             </div>

//                             <div className="customer_story_card_content">
//                                 <div>
//                                     <p className="customer_story_card_type">{item.tag}</p>
//                                     <h3 className="customer_story_card_title">{item.title}</h3>
//                                 </div>
//                                 <p className="customer_story_card_time">{item.location}</p>
//                             </div>

//                         </Link>
//                     ))}
//                 </div>
//             </div>
//         </div>
//       </div>
//     );
// }


import React, { useRef } from 'react'
import './css/exploreCaseStudy.css'
import { HashLink as Link } from "react-router-hash-link";
export const customerStories = [
    {
        id: 8,
        tag: 'CUSTOMER STORY',
        title: "A rebuild that made the caregiver's day simpler",
        location: '24 Hour Home Care',
        image: 'https://d2lyw5vkb9es5b.cloudfront.net/24_hr_story_banner.webp',
        url: "/customer-stories/24-hour-home-care-workforce-modernization",
    },
    {
        id: 15,
        tag: 'CUSTOMER STORY',
        title: "Support portal that lets hoteliers keep pace",
        location: 'Trivago',
        image: '/assets/customer-stories/trivago/hero.webp',
        url: "/customer-stories/trivago-support-portal",
    },
    {
        id: 16,
        tag: 'CUSTOMER STORY',
        title: "Making ARR easier to explain",
        location: 'Cambri',
        image: '/assets/customer-stories/cambri/08_background.png',
        url: "/customer-stories/making-arr-easier-to-explain",
    },
    {
        id: 1,
        tag: 'CUSTOMER STORY',
        title: "Bridging healthcare data gaps",
        location: 'Pacific West Diagnostic Imaging',
        image: 'https://d2lyw5vkb9es5b.cloudfront.net/MRIBgImg.webp',
        url: "/customer-stories/bridging-healthcare-data-gaps",
        customerStory:'',
        Industry:'',

    },
    {
        id: 2,
        tag: 'CUSTOMER STORY',
        title: 'Seamless Connection. Lasting Impact.',
        location: 'Debt Consultants Group',
        image: 'https://d2lyw5vkb9es5b.cloudfront.net/DCGbannerImag.webp',
        url: "/customer-stories/seamless-connection-lasting-impact"
    },
    {
        id: 3,
        tag: 'CUSTOMER STORY',
        title: "Instant Alerts. Connected Care.",
        location: 'PillTime',
        image: 'https://d2lyw5vkb9es5b.cloudfront.net/card2.webp',
        url: "/customer-stories/instant-alerts-connected-care"
    },
    {
        id: 4,
        tag: 'CUSTOMER STORY',
        title: "Powering, Vision 2030",
        location: 'World YMCA',
        image: 'https://d2lyw5vkb9es5b.cloudfront.net/YMCA201.webp',
        url: "/customer-stories/powering-vision-2030",
    },
    {
        id: 5,
        tag: 'CUSTOMER STORY',
        title: "Proven Revenue, Smartly Delivered",
        location: 'Elements Dining Group',
        image: 'https://d2lyw5vkb9es5b.cloudfront.net/ChatGPT20Image20Feb20232C2020262C2012_25_2020PM.webp',
        url: "/customer-stories/proven-revenue-smartly-delivered",
    },
    {
        id: 6,
        tag: 'CUSTOMER STORY',
        title: 'Unified Patient Provider Digital Ecosystem',
        location: 'ABA Therapy Provider',
        image: 'https://d2lyw5vkb9es5b.cloudfront.net/ChatGPT20Image20Feb20182C2020262C2007_19_5020PM.webp',
        url: "/customer-stories/unified-patient-provider-digital-ecosystem"
    },
    {
        id: 7,
        tag: 'CUSTOMER STORY',
        title: 'Where Data Drives Community Change',
        location: 'Grove Park Youth Club',
        image: 'https://d2lyw5vkb9es5b.cloudfront.net/2a8b30_f9a15c9a693c40439e8b140a463726a4~mv2.webp',
        url: "/customer-stories/where-data-drives-community-change"
    },
];
// const colorCode = ['#d1eb33', '#d12bdde0', '#2d58ed', '#ff7987']
const colorCode = [
    {
        'backgroundColor': '#d1eb33',
        'textColor': '#222',
        'paraColor': '#666'
    },
    {
        'backgroundColor': '#d12bdde0',
        'textColor': '#fff',
        'paraColor': '#fff'
    },

    {
        'backgroundColor': '#ff7987',
        'textColor': '#fff',
        'paraColor': '#fff'
    },
    {
        'backgroundColor': '#2d58ed',
        'textColor': '#fff',
        'paraColor': '#fff'
    }
]
export default function CustomerStory() {
   const lastColorIndex = useRef(-1); // single global tracker

const getRandomColor = () => {
    let newIndex;
    do {
        newIndex = Math.floor(Math.random() * colorCode.length);
    } while (newIndex === lastColorIndex.current);
    lastColorIndex.current = newIndex;
    return colorCode[newIndex];
};

const handleMouseEnter = (e) => {
    const color = getRandomColor();
    e.currentTarget.style.setProperty('--hoverBg', color.backgroundColor);
    e.currentTarget.style.setProperty('--titleColor', color.textColor);
    e.currentTarget.style.setProperty('--paraColor', color.paraColor);
};
    return (
      <div style={{backgroundColor:'#fff'}}>
          <div className="container" id='customer-stories' style={{backgroundColor:'#fff'}}>
            <div className="ExploreCaseStudySection">
                <p className="sectionLabel">Customer Stories</p>
                <h2>Featured Insights</h2>
                <div className='customer_story_container'>
                    {customerStories.map((item, index) => (
                        <Link
                            className="customer_story_card"
                            key={index}
                            to={item.url}
                            onMouseEnter={(e) => handleMouseEnter(e, item.id)}
                        >
                            <div className="customer_story_card_image">
                                <img src={item.image} alt={item.location} />
                            </div>
                            <div className="customer_story_card_content">
                                <div>
                                    <p className="customer_story_card_type">{item.tag}</p>
                                    <h3 className="customer_story_card_title">{item.title}</h3>
                                </div>
                                <p className="customer_story_card_time">{item.location}</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
      </div>
    );
}
